<template>
    <div>
        <navigation-bar Close/>
        <div class="main container">
            <div class="d-flex pay-list" @click="goPayPassword()">
                <div class="flex-grow-1">
                    <h3>更換支付密碼</h3>
                    <p>輸入舊密碼，即可更換新密碼</p>
                </div>
                <i class="el-icon-arrow-right yellow"/>
            </div>
            <el-divider class="m-0"/>
            <div class="d-flex pay-list" @click.stop="isShowDialog = true">
                <div class="flex-grow-1">
                    <h3>解除{{oinPayName}}</h3>
                    <p>停止使用並清除本機所有支付設定資料</p>
                </div>
                <i class="el-icon-arrow-right yellow"/>
            </div>
            <comm-dialog :value="isShowDialog"
                         :outerContent="`確定解除${oinPayName}？`"
                         @result="onDialogResult"/>
        </div>
    </div>
</template>

<script>
    import CommDialog from "@/components/CommDialog";
    import * as constDefine from "@/store/constDefine";
    import auth from "@/util/auth";
    export default {
        name: "PayEdit",
        components: {
            CommDialog,
        },
        data() {
            return {
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",
                dataObject: {},
                isShowDialog: false,
                oinPayName: constDefine.OinPayName,
            }
        },
        created() {
            try {
                let dataObject = this.$crypto.uriComponentToObject(this.dataToken)
                if (dataObject.usedType === this.$route.name) {
                    this.dataObject = dataObject
                } else {
                    this.$public.showNotify("參數異常", false);
                    this.$router.push({name: 'More'})
                }
            } catch (e) {
                this.$public.showNotify("參數異常", false);
                this.$router.push({name: 'More'})
            }
        },
        methods: {
            onDialogResult(isSure) {
                if (isSure) {
                    this.$http.fetchWithAuthEncrypt`DeleteOinPay${{
                        userToken: auth.getAdminToken(),
                    }}
                    ${json => {
                        this.isShowDialog = false
                        this.$public.showNotify(json.message, json.status);
                        if (json.status) {
                            this.$store.commit("updateCartPaymentType", {});
                            this.$router.push({name: 'More'})
                        }
                    }}`;
                } else {
                    this.isShowDialog = false
                }
            },
            goPayPassword() {
                let self = this;
                let routerName = "PayPassword"
                let dataToken = self.$crypto.objectToURIComponent({
                    usedType: routerName,
                    isHavePayPassword: self.dataObject.isHavePayPassword,
                    isUpdatePayPassword: true,
                    successRouterName: "OINPay",
                })

                self.$router.push({name: routerName, query: {'dataToken': dataToken}})
            },
        },

    }
</script>

<style lang="less" scoped src="../../less/pay.less"/>
